import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {CommandUtil} from '../../../global/commandutil';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {environment} from '../../../../environments/environment';
import {DangKy} from '../../../models/vpp/dangky';
import {Sessioncommand} from '../../../global/sessioncommand';
import {DangKyHopService} from '../../../service/vpp/service-dangkyhop';
import {Phong} from '../../../models/danhmuc/phong';
import {PhongService} from '../../../service/danhmuc/service-phong';
import {DangKyHop} from '../../../models/vpp/dangkyhop';
import {DetailDangKyPhongComponent} from './detail.component';

@Component({
  templateUrl: './xemkq.component.html',
  encapsulation: ViewEncapsulation.None
})
export class XemKQDangKyPhongComponent implements OnInit, AfterViewInit {
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public frmGroup: FormGroup;
  public dataList: DangKyHop[];
  public srTitle: string = '';
  public srPhong: number = -1;

  public dataPhong: Phong[];
  constructor( public dangKyService: DangKyHopService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public phongService: PhongService,
               public commandUtil: CommandUtil

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.search();
    this.phongService.getAll().subscribe(data => this.dataPhong = data);

  }
  public detail(id: number): void {

    const modalEdit = this.bsModalService.show(DetailDangKyPhongComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<DetailDangKyPhongComponent>modalEdit.content).edit(
      id
    );
    (<DetailDangKyPhongComponent>modalEdit.content).onClose.subscribe(result => {
    });

  }
  search()
  {

    this.dangKyService.findAllByPaging(this.srTitle, this.srPhong, '2,3', Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.dangKyService.getCountByKeyword(this.srTitle, this.srPhong, '2,3', Sessioncommand.staffId).subscribe(recordCount => this.totalItems = recordCount);
  }


  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

